export interface CallRecord {
  id: number;
  leadName: string;
  phone: string;
  agent: string;
  date: string;
  dateSort: string;
  duration: string;
  durationSeconds: number;
  status: "Connected" | "Missed" | "Busy";
  hasRecording: boolean;
}

export interface TranscriptLine {
  time: string;
  seconds: number;
  speaker: "agent" | "customer";
  speakerName: string;
  text: string;
}

export interface AISummary {
  keyPoints: string[];
  sentimentLabel: string;
  sentimentScore: number;
  nextAction: string;
}

export interface CallNote {
  text: string;
  author: string;
  time: string;
}

export const transcriptData: Record<number, TranscriptLine[]> = {
  1: [
    { time: "0:00", seconds: 0, speaker: "agent", speakerName: "Rajesh Kumar", text: "Hello, am I speaking with Vikram?" },
    { time: "0:04", seconds: 4, speaker: "customer", speakerName: "Vikram Mehta", text: "Yes, this is Vikram." },
    { time: "0:06", seconds: 6, speaker: "agent", speakerName: "Rajesh Kumar", text: "Hi Vikram, I'm Rajesh from PropMax Solutions. You had enquired about a 3BHK flat in Bandra West." },
    { time: "0:14", seconds: 14, speaker: "customer", speakerName: "Vikram Mehta", text: "Yes that's right. What is the current price?" },
    { time: "0:18", seconds: 18, speaker: "agent", speakerName: "Rajesh Kumar", text: "The price is 82 lakhs for 1450 sq ft, fully furnished." },
    { time: "0:25", seconds: 25, speaker: "customer", speakerName: "Vikram Mehta", text: "That seems a bit high. Can you do 78 lakhs?" },
    { time: "0:30", seconds: 30, speaker: "agent", speakerName: "Rajesh Kumar", text: "Let me check with the owner. Can we schedule a site visit first this weekend?" },
    { time: "0:38", seconds: 38, speaker: "customer", speakerName: "Vikram Mehta", text: "Sure, Saturday morning works for me." },
    { time: "0:42", seconds: 42, speaker: "agent", speakerName: "Rajesh Kumar", text: "Perfect. I'll send you the address on WhatsApp. See you Saturday at 10 AM." },
    { time: "0:48", seconds: 48, speaker: "customer", speakerName: "Vikram Mehta", text: "Sounds good, thank you." },
    { time: "0:50", seconds: 50, speaker: "agent", speakerName: "Rajesh Kumar", text: "Thank you Vikram, have a great day!" },
  ],
  3: [
    { time: "0:00", seconds: 0, speaker: "agent", speakerName: "Rajesh Kumar", text: "Hello Suresh, this is Rajesh from PropMax." },
    { time: "0:03", seconds: 3, speaker: "customer", speakerName: "Suresh Nair", text: "Hi Rajesh, thanks for calling back." },
    { time: "0:06", seconds: 6, speaker: "agent", speakerName: "Rajesh Kumar", text: "I'm calling about the 2BHK in Powai you viewed yesterday." },
    { time: "0:12", seconds: 12, speaker: "customer", speakerName: "Suresh Nair", text: "Yes, I liked the property. What's the final offer?" },
    { time: "0:17", seconds: 17, speaker: "agent", speakerName: "Rajesh Kumar", text: "The final price is ₹1.15 Cr including all charges." },
    { time: "0:24", seconds: 24, speaker: "customer", speakerName: "Suresh Nair", text: "Okay, let me discuss with my family and get back to you tomorrow." },
    { time: "0:30", seconds: 30, speaker: "agent", speakerName: "Rajesh Kumar", text: "Of course. I'll send the brochure on WhatsApp for reference." },
    { time: "0:35", seconds: 35, speaker: "customer", speakerName: "Suresh Nair", text: "Great, thanks Rajesh." },
  ],
  4: [
    { time: "0:00", seconds: 0, speaker: "agent", speakerName: "Amit Patel", text: "Hi Kavita, Amit here from PropMax. How was the site visit?" },
    { time: "0:04", seconds: 4, speaker: "customer", speakerName: "Kavita Joshi", text: "It was great! The flat is beautiful. I have a few questions though." },
    { time: "0:10", seconds: 10, speaker: "agent", speakerName: "Amit Patel", text: "Sure, go ahead." },
    { time: "0:12", seconds: 12, speaker: "customer", speakerName: "Kavita Joshi", text: "What about parking and society maintenance?" },
    { time: "0:17", seconds: 17, speaker: "agent", speakerName: "Amit Patel", text: "Two covered parking spots included. Maintenance is ₹4,200 per month." },
    { time: "0:25", seconds: 25, speaker: "customer", speakerName: "Kavita Joshi", text: "Okay that's reasonable. I'll get back to you with a decision by tomorrow evening." },
    { time: "0:32", seconds: 32, speaker: "agent", speakerName: "Amit Patel", text: "Sounds good Kavita. Looking forward to hearing from you." },
  ],
  6: [
    { time: "0:00", seconds: 0, speaker: "agent", speakerName: "Priya Sharma", text: "Hello Deepika! Priya from PropMax. Ready to finalize?" },
    { time: "0:03", seconds: 3, speaker: "customer", speakerName: "Deepika Singh", text: "Yes Priya! We loved the Andheri 2BHK. Let's go ahead." },
    { time: "0:08", seconds: 8, speaker: "agent", speakerName: "Priya Sharma", text: "Wonderful! I'll prepare the agreement. When can you come to sign?" },
    { time: "0:14", seconds: 14, speaker: "customer", speakerName: "Deepika Singh", text: "Tomorrow at 11 AM works." },
    { time: "0:17", seconds: 17, speaker: "agent", speakerName: "Priya Sharma", text: "Perfect. Bring your ID proof and 2 passport photos." },
    { time: "0:22", seconds: 22, speaker: "customer", speakerName: "Deepika Singh", text: "Will do. Thank you so much!" },
  ],
};

export const aiSummaryData: Record<number, AISummary> = {
  1: {
    keyPoints: [
      "Customer interested in 3BHK Bandra West",
      "Budget: 78-82 lakhs (negotiating)",
      "Site visit scheduled: Saturday 10 AM",
      "Price objection raised on 82L quote",
    ],
    sentimentLabel: "Positive",
    sentimentScore: 65,
    nextAction: "Send site visit confirmation on WhatsApp and prepare price negotiation brief",
  },
  3: {
    keyPoints: [
      "Customer viewed 2BHK in Powai",
      "Final price quoted: ₹1.15 Cr",
      "Customer needs to discuss with family",
      "Brochure sent via WhatsApp",
    ],
    sentimentLabel: "Neutral",
    sentimentScore: 55,
    nextAction: "Follow up tomorrow afternoon for decision update",
  },
  4: {
    keyPoints: [
      "Site visit completed successfully",
      "Questions about parking and maintenance answered",
      "Maintenance ₹4,200/month confirmed",
      "Decision expected by tomorrow evening",
    ],
    sentimentLabel: "Positive",
    sentimentScore: 70,
    nextAction: "Follow up tomorrow evening if no response received",
  },
  6: {
    keyPoints: [
      "Customer confirmed booking for Andheri 2BHK",
      "Agreement signing scheduled tomorrow 11 AM",
      "Customer asked to bring ID and photos",
      "Deal value: ₹92 Lakhs",
    ],
    sentimentLabel: "Very Positive",
    sentimentScore: 90,
    nextAction: "Prepare agreement documents and booking receipt",
  },
};

export const callNotesData: Record<number, CallNote[]> = {
  1: [
    { text: "Vikram open to negotiation. Scheduled site visit for Saturday. Follow up with WhatsApp confirmation.", author: "Rajesh Kumar", time: "Today 10:35 AM" },
  ],
  3: [
    { text: "Suresh liked the Powai property. Price negotiation at 1.15 Cr. Will follow up tomorrow.", author: "Rajesh Kumar", time: "Today 2:05 PM" },
  ],
  4: [
    { text: "Kavita impressed with the property. Answered all questions about amenities. Expecting positive response.", author: "Amit Patel", time: "Yesterday 4:40 PM" },
  ],
  6: [
    { text: "Deepika confirmed booking! Preparing documents for tomorrow signing at 11 AM.", author: "Priya Sharma", time: "Yesterday 11:10 AM" },
  ],
};

export const highlightedKeywords = ["78 lakhs", "82 lakhs", "Saturday", "site visit", "10 AM", "1.15 Cr", "₹1.15 Cr", "agreement", "tomorrow"];

export const callsData: CallRecord[] = [
  { id: 1, leadName: "Vikram Mehta", phone: "9876543210", agent: "Rajesh Kumar", date: "Today 10:30 AM", dateSort: "2026-06-25T10:30", duration: "5m 20s", durationSeconds: 320, status: "Connected", hasRecording: true },
  { id: 2, leadName: "Anita Desai", phone: "9845123456", agent: "Priya Sharma", date: "Today 11:15 AM", dateSort: "2026-06-25T11:15", duration: "0m", durationSeconds: 0, status: "Missed", hasRecording: false },
  { id: 3, leadName: "Suresh Nair", phone: "9712345678", agent: "Rajesh Kumar", date: "Today 2:00 PM", dateSort: "2026-06-25T14:00", duration: "3m 45s", durationSeconds: 225, status: "Connected", hasRecording: true },
  { id: 4, leadName: "Kavita Joshi", phone: "9632145870", agent: "Amit Patel", date: "Yesterday 4:30 PM", dateSort: "2026-06-24T16:30", duration: "8m 12s", durationSeconds: 492, status: "Connected", hasRecording: true },
  { id: 5, leadName: "Rahul Verma", phone: "9521478963", agent: "Sneha Rao", date: "Yesterday 3:00 PM", dateSort: "2026-06-24T15:00", duration: "0m", durationSeconds: 0, status: "Busy", hasRecording: false },
  { id: 6, leadName: "Deepika Singh", phone: "9415263780", agent: "Priya Sharma", date: "Yesterday 11:00 AM", dateSort: "2026-06-24T11:00", duration: "6m 05s", durationSeconds: 365, status: "Connected", hasRecording: true },
  { id: 7, leadName: "Sunita Rao", phone: "9201364875", agent: "Rajesh Kumar", date: "2 days ago 10:00 AM", dateSort: "2026-06-23T10:00", duration: "2m 30s", durationSeconds: 150, status: "Connected", hasRecording: true },
  { id: 8, leadName: "Manoj Tiwari", phone: "9854123670", agent: "Priya Sharma", date: "2 days ago 3:45 PM", dateSort: "2026-06-23T15:45", duration: "0m", durationSeconds: 0, status: "Missed", hasRecording: false },
  { id: 9, leadName: "Arjun Kapoor", phone: "9308547621", agent: "Amit Patel", date: "3 days ago 9:30 AM", dateSort: "2026-06-22T09:30", duration: "4m 55s", durationSeconds: 295, status: "Connected", hasRecording: true },
  { id: 10, leadName: "Pooja Menon", phone: "9741258036", agent: "Sneha Rao", date: "3 days ago 2:15 PM", dateSort: "2026-06-22T14:15", duration: "1m 20s", durationSeconds: 80, status: "Connected", hasRecording: true },
];

export interface ScheduledCall {
  id: number;
  leadName: string;
  company: string;
  phone: string;
  time: string;
  timeSort: string;
  purpose: string;
  agent: string;
}

export const scheduledCalls: ScheduledCall[] = [
  { id: 1, leadName: "Sarah Chen", company: "TechVentures", phone: "9812345678", time: "Today 3:30 PM", timeSort: "2026-06-25T15:30", purpose: "Demo", agent: "Rajesh Kumar" },
  { id: 2, leadName: "Marcus Webb", company: "Skyline", phone: "9723456789", time: "Today 4:00 PM", timeSort: "2026-06-25T16:00", purpose: "Follow-up", agent: "Priya Sharma" },
  { id: 3, leadName: "Elena Ruiz", company: "GreenLeaf", phone: "9634567890", time: "Today 4:15 PM", timeSort: "2026-06-25T16:15", purpose: "Proposal", agent: "Amit Patel" },
  { id: 4, leadName: "Ravi Iyer", company: "CloudFirst", phone: "9812345670", time: "Tomorrow 10:00 AM", timeSort: "2026-06-26T10:00", purpose: "Discovery", agent: "Rajesh Kumar" },
  { id: 5, leadName: "Neha Gupta", company: "MediCare", phone: "9545678901", time: "Tomorrow 2:30 PM", timeSort: "2026-06-26T14:30", purpose: "Demo", agent: "Sneha Rao" },
];